<template>
	<div class="study">
		<publicHeader @child-event="parentEvent"></publicHeader>
		<personalHeader :myInfo="myInfo"></personalHeader>
		
		<div class="personal bg_gray">
			<div class="w1200 flex">
				<personalNav :current="current"></personalNav>
				<div class="personal_r bg_white radius8">
					<div class="personal_title mab20">
						<i class="f20px cl_dark mar10">充值中心</i>
						<!-- <span class="cl_gray mal10">趣币目前是用于趣学云课程付费</span> -->
					</div>
					<div class="payment">
						<div class="personal_item">
							<p class="personal_item_l f16px cl_gray"><span class="inline">充值账户</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="f16px" v-if="myInfo.real_name != null">{{myInfo.real_name}}</span>
								<span class="f16px" v-if="myInfo.real_name == null && myInfo.name != null">{{myInfo.name}}</span>
								<span class="f16px" v-if="myInfo.real_name == null && myInfo.name == null && myInfo.wx_nickname != null">{{myInfo.wx_nickname}}</span>
							</div>
						</div>
						<div class="personal_item">
							<p class="personal_item_l f16px cl_gray"><span class="inline">充值方式</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<div class="payment_list radius8" v-for="item in payment" :key="item.id" :class="{'on':item.id==paymentCur}" @click="paymentList(item.id)">
									<img :src="item.pic" class="payment_list_img" />
									<img src="../../../static/icon_checked.png" class="payment_list_tip" />
								</div>
							</div>
						</div>
						<div class="personal_item">
							<p class="personal_item_l f16px cl_gray"><span class="inline">充值金额</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<div class="money_list bg_gray cl_gray tc" v-for="(item,index) in money" :key="index" :class="{'on':item.id==moneyCur.id}" @click="moneyList(index)">{{item.name}}</div>
							</div>
						</div>
						<div class="personal_item">
							<p class="personal_item_l f16px cl_gray"><span class="inline">应付金额</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<p class="f16px payment_total"><span class="cl_yel f26px">{{moneyCur.pay_money}}</span>&nbsp;&nbsp;元（获得 {{moneyCur.charge_money}}）</p>
							</div>
						</div>
						<div class="personal_payment_btm mat30">
							<button type="button" class="f16px cl_white personal_payment radius20" @click="paymentBtn">去支付</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
		<!-- 微信支付 -->
		<el-dialog title="微信支付" :visible.sync="wxShow" width="30%" :close-on-click-modal="false" :center="true" :destroy-on-close="true">
		  <div class="tc">
				<div class="qrcode inline" ref="qrCodeUrl"></div>
			</div>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="wxShow = false">取 消</el-button>
		    <el-button type="primary" @click="wxConfirm">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	import personalHeader from '../../components/personal_header.vue'
	import personalNav from '../../components/personal_nav.vue'
	import QRCode from 'qrcodejs2'
	export default {
	  name: 'payment',
		components: {
			publicHeader,
			vfooter,
			personalHeader,
			personalNav,
		},
	  props: {
	    
	  },
		data () {
			return {
				myInfo: {},
				current: {
					navCur: 2,
					listCur: 4,
				},
				paymentCur: 2,
				payment: [
					{
						id: 2,
						pic: require("../../../static/payment_01.png"),
					},{
						id: 3,
						pic: require("../../../static/payment_02.png"),
					},
				],
				moneyCur: {},
				money: [],
				wxShow: false, //微信支付
				order_no: "", //订单号
			}
		},
		mounted() {
			this.getCharge();
		},
		created() {
			
		},
		methods: {
			parentEvent (data) {
				this.myInfo = data;
			},
			paymentList (e) {
				this.paymentCur = e;
			},
			getCharge () {
				this.$get("/api/recharge/get_charge_opt_data",{})
				.then(res => {
					this.money = res.data;
					this.moneyCur = this.money[0];
				});
			},
			moneyList (e) {
				this.moneyCur = this.money[e];
			},
			paymentBtn () {
				let return_url = window.location.href;
				if (this.paymentCur == 2) {
					window.open('http://res.joy366.com/api/chargeopt/add_charge_order?token='+ localStorage.getItem("token") +'&id='+ this.moneyCur.id +'&type='+ this.paymentCur +'&return_url='+ return_url + '&platform=1', '_blank');
				} else {
					this.$get("/api/chargeopt/add_charge_order",{
						token: localStorage.getItem("token"),
						id: this.moneyCur.id,
						type: this.paymentCur,
						return_url: return_url,
						platform: 1, //1pc;2h5;3app
					})
					.then(res => {
						this.wxShow = true;
						this.order_no = res.data.order_no;
						setTimeout(() => {
							this.creatQrCode(res.data.code_url);
						}, 0);
					});
				}
			},
			//生成二维码
			creatQrCode(url) {
				var qrcode = new QRCode(this.$refs.qrCodeUrl, {
					text: url,
					width: 250,
					height: 250,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			},
			wxConfirm () {
				this.$get("/api/chargeopt/order_no_show",{
					token: localStorage.getItem("token"),
					order_no: this.order_no,
				})
				.then(res => {
					if (res.data == 0) {
						this.$message({
							duration: 1500,
							message: "请先扫描支付",
							type: 'warning'
						});
						return false
					} else if (res.data == 1) {
						this.$message({
							duration: 1500,
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							location.reload();
						}, 1500);
					}
				});
			},
		},
	}
</script>

<style>
</style>
